export default 'projectSalesApp';
